import { DynamicToolUIPart, ToolUIPart, getToolName } from 'ai';
import LangEnum from '../../../../lang/LangEnum';
import { useSetRachelChatToolApprovalMutation } from '../../../../services/modules/rachelChats/rachelChats.mutations';
import { useTranslation } from '../../../translation/TranslationContext';
import { useRachelChatContext } from '../../contexts/Rachel.context';
import { useRachelActiveChatId } from '../../hooks/useRachelActiveChatId';
import { useRachelErrorReporter } from '../../hooks/useRachelErrorReporter';
import { useRachelPresentation } from '../../hooks/useRachelPresentation';
import { getToolApprovalAction } from './toolApprovalLabel';

export const useToolPart = (part: ToolUIPart | DynamicToolUIPart) => {
  const { translate } = useTranslation();
  const { addToolApprovalResponse } = useRachelChatContext();
  const { isMaximized } = useRachelPresentation();
  const { reportRachelError } = useRachelErrorReporter();
  const { mutateAsync: setToolApproval } = useSetRachelChatToolApprovalMutation();

  const activeChatId = useRachelActiveChatId();

  const toolName = getToolName(part);
  const approvalId = part.state === 'approval-requested' ? part.approval.id : undefined;
  const approvalAction = getToolApprovalAction(toolName, part.input);

  const respondToApproval = (isApproved: boolean) => {
    if (approvalId) {
      addToolApprovalResponse(approvalId, isApproved);
    }
  };

  const allowWithApprovalUpdate = async (params: { toolName: string } | { yoloMode: boolean }) => {
    try {
      if (!activeChatId) {
        throw new Error('tool approval requested without an active chat');
      }

      await setToolApproval({ chatId: activeChatId, ...params });
      respondToApproval(true);
    } catch (error) {
      reportRachelError(error);
    }
  };

  return {
    toolName,
    isExpanded: isMaximized,
    approvalPrompt: translate(LangEnum.RACHEL_APPROVAL_PROMPT, {
      action: translate(approvalAction.labelKey, approvalAction.values),
    }),
    handleAllow: () => respondToApproval(true),
    handleAllowAlways: () => allowWithApprovalUpdate({ toolName }),
    handleAllowAllChat: () => allowWithApprovalUpdate({ yoloMode: true }),
    handleDecline: () => respondToApproval(false),
  };
};
